import { Link } from "react-router-dom";
import * as React from "react";
import { developAxios } from "../axios.config";
import { Alert } from "react-bootstrap";

const CreateProject = () => {
	const [course, setCourse] = React.useState("");
	const [courses, setCourses] = React.useState([]);

	const [imageUri, setImageUri] = React.useState("");

	const [imageFile, setImageFile] = React.useState(null);

	const [projectImageIcon, setProjectImageIcon] = React.useState("");
	const [projectImageIconFile, setProjectImageIconFile] =
		React.useState(null);

	const [projectName, setProjectName] = React.useState("");
	const [projectDescription, setProjectDescription] = React.useState("");

	const onImageChange = (event) => {
		if (event.target.files && event.target.files[0]) {
			let reader = new FileReader();
			let file = event.target.files[0];
			setImageFile(file);
			reader.onloadend = () => {
				setImageUri(reader.result);
			};
			reader.readAsDataURL(file);
		}
	};

	// select course
	React.useEffect(() => {
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/getallcourse", {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setCourses(data.courses);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, []);

	const handleSubmit = (e) => {
		e.preventDefault();
		const formData = new FormData();
		formData.append("projectImage", imageFile);
		formData.append("courseId", course);
		formData.append("projectName", projectName);
		formData.append("projectDescription", projectDescription);
		formData.append("projectIcon", projectImageIconFile);
		developAxios(localStorage.getItem("token"))
			.post("/dashboard/create-project", formData)
			.then(({ data }) => {
				console.log(data);
				alert("Project Created Successfully");
				window.location.reload();
			})
			.catch((err) => console.log(err?.response));
	};

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "flex-start",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					alignSelf: "center",
					width: "500px",
					paddingBottom: "50px",
					paddingTop: "50px",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<h5>Course ID:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="course_select"
						id="course_select"
						onChange={(e) => {
							// set id of course
							setCourse(e.target.value);
						}}
					>
						<option value="">Select Course</option>
						{courses.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.name}
								</option>
							);
						})}
					</select>
				</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Name:</h5>{" "}
					<input
						type="text"
						name="project_name"
						id="project_name"
						onChange={(e) => {
							setProjectName(e.target.value);
						}}
					/>
				</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Description:</h5>{" "}
					<input
						type="text"
						name="project_description"
						id="project_description"
						onChange={(e) => {
							setProjectDescription(e.target.value);
						}}
					/>
				</div>

				{/* Project Image upload */}
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Image:</h5>{" "}
					<input
						type="file"
						accept="image/*"
						name="project_image"
						id="project_image"
						onChange={onImageChange}
					/>
				</div>

				{/* Show selected image */}
				{imageUri && (
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							marginTop: "20px",
						}}
					>
						<h5>Selected Image:</h5>{" "}
						<img
							src={imageUri}
							alt="Avatar"
							className="avatar"
							style={{
								height: "200px",
								objectFit: "contain",
							}}
						/>
					</div>
				)}

				{/* Project Image icon */}
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Image Icon:</h5>{" "}
					<input
						type="file"
						accept="image/*"
						name="project_image_icon"
						id="project_image_icon"
						onChange={(e) => {
							if (e.target.files && e.target.files[0]) {
								let reader = new FileReader();
								let file = e.target.files[0];
								setProjectImageIconFile(file);
								reader.onloadend = () => {
									setProjectImageIcon(reader.result);
								};
								reader.readAsDataURL(file);
							}
						}}
					/>
				</div>

				{/* Show selected image */}
				{projectImageIcon && (
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							marginTop: "20px",
						}}
					>
						<h5>Selected Image:</h5>{" "}
						<img
							src={projectImageIcon}
							alt="Avatar"
							className="avatar"
							style={{
								height: "200px",
								objectFit: "contain",
							}}
						/>
					</div>
				)}

				{/* Create Project button */}

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<button
						className="btn btn-primary"
						style={{
							height: "50px",
						}}
						onClick={handleSubmit}
					>
						Create Project
					</button>
				</div>
			</div>
		</div>
	);
};

export default CreateProject;
